<template>
  <v-container>
    <v-row><h1>Visitor Forms</h1></v-row>
    <v-row><p class="error" v-if="error">{{ error }}</p></v-row>

    <v-data-table
      :headers="headers"
      :items="answers"
    >
    </v-data-table>

  </v-container>
</template>

<script>
import FormService from '../services/FormService';
import UserService from '../services/UserService';

export default {
  name: 'VisitorForms',
  data() {
    return {
      forms: [],
      error: '',
      headers: [
        { text: 'Time', value: 'time' },
        { text: 'Name', value: 'name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Company', value: 'company' },
        { text: 'Screening Questions Passed', value: 'screening' },

        { text: 'Temp', value: 'temp' },
      ],
      selectedBusinessId: '',
      user: {},
      userId: this.$auth.user.sub.split('|')[1],
    };
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    this.user = await UserService.getUser(this.userId, token);
    const { businessIds } = this.user;
    if (businessIds.length > 0) {
      [this.selectedBusinessId] = businessIds;
      this.updateFormList();
    }
  },
  methods: {
    async updateFormList() {
      const token = await this.$auth.getTokenSilently();
      FormService.listForms(this.selectedBusinessId, token)
        .then((forms) => { this.forms = forms; })
        .catch(this.reportError);
    },
    reportError(err) {
      this.error = err.message;
    },
  },
  computed: {
    answers() {
      return this.forms.map((form) => {
        const { hidden } = form.form_response;
        const { answers } = form.form_response;
        const screeningPassed = answers[6].boolean && answers[7].boolean && answers[8].boolean ? 'False' : 'True';
        return {
          time: hidden.time,
          name: `${answers[0].text} ${answers[1].text}` || '',
          phone: answers[2].phone_number || '',
          email: answers[3].email || '',
          company: answers[4].text || '',
          screening: screeningPassed || '',
          temp: hidden.temp || '',
        };
      });
    },
    // questionMap() {
    //   const forms = [...this.forms];
    //   if (forms.length === 0) return {};
    //   const fields = [].concat(forms.map((form) => (form?.definition?.fields || [])));
    //   const questionMap = {};
    //   fields.forEach((field) => {
    //     if (questionMap[field.id] === undefined) {
    //       questionMap[field.id] = field.title;
    //     }
    //   });
    //   return questionMap;
    // },
    // answers() {
    //   return this.forms.map((form) => {
    //     const formAnswers = form.answers || [];
    //     const reducedForm = {};
    //     formAnswers.forEach((a) => {
    //       const question = this.questionMap[a.field.id];
    //       reducedForm[question] = a[a.type];
    //     });
    //     return reducedForm;
    //   });
    // },
    // headers() {
    //   return Object.values(this.questionMap);
    // },
  },
};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}

</style>
